import YakFetch from './utils/yak_fetch';
import ServiceBase from './service_base';
import TokenStorage from './utils/token_storage';

export default class UserLogin extends ServiceBase {

  static async login(authToken) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/account`
    const response = await YakFetch.fetch(endpoint, 'GET', { token: authToken });
    await UserLogin._abortIfUnsuccessful(response);
    TokenStorage.storeAuthToken(authToken);
    const userData = await response.json();
    return userData;
  }

  static logout() {
    TokenStorage.destroyAuthToken();
  }

  static isLoggedIn() {
    return (TokenStorage.getAuthToken() !== null && TokenStorage.getAuthToken().length > 0);
  }
}



// WEBPACK FOOTER //
// ./src/services/user_login.js